import React from 'react';

const formatCount = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
        return '0';
    }

    return number.toLocaleString();
};

const Pagination = ({ currentPage, totalPages, onPageChange, totalElements, pageSize }) => {
    const maxVisiblePages = 5;

    const getPageNumbers = () => {
        const pages = [];
        let startPage = Math.max(0, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages - 1, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(0, endPage - maxVisiblePages + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    };

    const startItem = currentPage * pageSize + 1;
    const endItem = Math.min((currentPage + 1) * pageSize, totalElements);

    return (
        <div className="d-flex justify-content-between align-items-center mt-4">
            <div className="text-muted small">
                {totalPages > 0 && (
                    <>
                        Page {formatCount(currentPage + 1)} of {formatCount(totalPages)}
                        <span className="mx-1">·</span>
                    </>
                )}
                Showing {formatCount(startItem)} to {formatCount(endItem)} of {formatCount(totalElements)} entries
            </div>
            <nav aria-label="Page navigation">
                <ul className="pagination pagination-sm mb-0">
                    {/* First Page */}
                    <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(0)}
                            disabled={currentPage === 0}
                        >
                            <i className="bi bi-chevron-double-left"></i>
                        </button>
                    </li>

                    {/* Previous Page */}
                    <li className={`page-item ${currentPage === 0 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 0}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </button>
                    </li>

                    {/* Page Numbers */}
                    {getPageNumbers().map(page => (
                        <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                            <button
                                className="page-link"
                                onClick={() => onPageChange(page)}
                            >
                                {page + 1}
                            </button>
                        </li>
                    ))}

                    {/* Next Page */}
                    <li className={`page-item ${currentPage >= totalPages - 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage >= totalPages - 1}
                        >
                            <i className="bi bi-chevron-right"></i>
                        </button>
                    </li>

                    {/* Last Page */}
                    <li className={`page-item ${currentPage >= totalPages - 1 ? 'disabled' : ''}`}>
                        <button
                            className="page-link"
                            onClick={() => onPageChange(totalPages - 1)}
                            disabled={currentPage >= totalPages - 1}
                        >
                            <i className="bi bi-chevron-double-right"></i>
                        </button>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Pagination;